import React from 'react'
import { useContext } from 'react';
import noteContext from '../context/Notes/NoteContext';
import { useState } from 'react';
import ScrollReveal from 'scrollreveal';

export const Noteitem = (props) => {

    ScrollReveal().reveal('.col-md-3')

    const context = useContext(noteContext)
    const { deletenote, editnote } = context
    const [note, setnote] = useState(props.note)
    const [etitle, setetitle] = useState(note.title)
    const [edescription, setedescription] = useState(note.description)

    const ontitlechange = (e) => {
        setetitle(e.target.value)
    }

    const ondescchange = (e) => {
        setedescription(e.target.value)
    }

    const {showalert} = props;

    const handleclick = async () => {
        let newnote = { title: etitle, description: edescription, tag: "" }
        await setnote(newnote);
        editnote(note._id, etitle, edescription);
    }

    return (
        <>
            <div className="modal fade" id={`${note._id}`} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">Modal title</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form className="my-4">
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" className="form-label">Title</label>
                                    <input type="text" value={etitle} onChange={ontitlechange} className="form-control" id="etitle" name='etitle' />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputPassword1" className="form-label">Description</label>
                                    <input type="text" value={edescription} onChange={ondescchange} className="form-control" id="edescription" name="edescription" rows={5} />
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="button" id={etitle} className="btn btn-primary" onClick={() => { handleclick() }}>Save changes</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-3 card mx-2 my-2 shadow">
                <div className="card-body">
                    <h5 className="card-title">{note.title}</h5>
                    <p className="card-text">{note.description}</p>
                    <i className="fa-solid fa-trash mx-2" onClick={()=>{deletenote(note._id);props.showalert("Deleted Successfully","success")}}></i>
                    <i className="fa-solid fa-pen-to-square mx-2" role='button' type="button" data-bs-toggle="modal" data-bs-target={`#${note._id}`}></i>
                </div>
            </div>
        </>
    )
}


export default Noteitem;